module.exports = __webpack_public_path__ + "img/p72.b576a71d.png";